// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"105":"cart-handler","172":"list-handler"}[chunkId] + "." + {"105":"8acc9a50","172":"91d344d2"}[chunkId] + ".js";
};